import { useCallback, useContext } from 'react'

import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import CopyCode from 'features/licenses/components/LicensesGroupsTable/CopyCode'
import type { LicenseType } from 'features/licenses/types'
import MobileLabelLine from 'components/MobileWhiteCardLine'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import { LicensesContext } from 'features/licenses/LicensesContext'
import { useAppSelector } from 'app/hooks'

import LicenseStatuses from '../LicenseStatuses'
import Note from './Note'
import {
  LicensesAvailableCodesMobileContainer,
  LicensesAvailableCodesMobileHeader,
  LicensesMobileCopyCodeWrapper,
} from './styles'
import LicenseRowActions from './LicenseRowActions'

interface LicensesAvailableCodesMobileProps {
  values: Record<string, any>
  original: LicenseType
}

/**
 * @todo localization
 */

function LicensesAvailableCodesMobile({
  values,
  original,
}: LicensesAvailableCodesMobileProps) {
  const currentRootId = useAppSelector(currentRootDomainIdSelector)
  const { setIsOpenReclaimModal, setIsOpenTransferModal, setSelectedLicense } =
    useContext(LicensesContext)

  const handleClickToReclaim = useCallback(() => {
    setSelectedLicense(original)
    setIsOpenReclaimModal(true)
  }, [original, setIsOpenReclaimModal, setSelectedLicense])

  const handleClickToTransfer = useCallback(() => {
    setSelectedLicense(original)
    setIsOpenTransferModal(true)
  }, [original, setIsOpenTransferModal, setSelectedLicense])

  return (
    <LicensesAvailableCodesMobileContainer>
      <LicensesAvailableCodesMobileHeader>
        <LicensesMobileCopyCodeWrapper>
          <CopyCode code={original.code} />
          <LicenseStatuses license={original} rootDomainId={currentRootId} />
        </LicensesMobileCopyCodeWrapper>
        <LicenseRowActions
          license={original}
          rootDomainId={currentRootId}
          onClickToReclaim={handleClickToReclaim}
          onClickToTransfer={handleClickToTransfer}
        />
      </LicensesAvailableCodesMobileHeader>
      <MobileLabelLine label="Order Number" value={values.orderNumber} />
      <MobileLabelLine label="Purchase Order" value={values.customerPO} />
      <MobileLabelLine
        label="Created"
        value={
          <IntlFormattedDate date={values.created} withTime defaultReturn="-" />
        }
      />
      <Note original={original} />
    </LicensesAvailableCodesMobileContainer>
  )
}

export default LicensesAvailableCodesMobile
